import React from 'react';
import { Button } from './ui/Button';
import { WaveformVisualizer } from './WaveformVisualizer';
import { Play } from 'lucide-react';
export function Hero() {
  return <section className="relative min-h-screen flex items-center justify-center pt-16 overflow-hidden" data-id="element-74">
      {/* Background Elements */}
      <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_center,_var(--tw-gradient-stops))] from-[#1a1a2e] via-[#0A0A0F] to-[#0A0A0F] z-0" data-id="element-75"></div>

      {/* Grid Pattern Overlay */}
      <div className="absolute inset-0 bg-[url('https://grainy-gradients.vercel.app/noise.svg')] opacity-20 z-0 mix-blend-overlay" data-id="element-76"></div>
      <div className="absolute inset-0 z-0 opacity-10" style={{
      backgroundImage: 'linear-gradient(#333 1px, transparent 1px), linear-gradient(90deg, #333 1px, transparent 1px)',
      backgroundSize: '40px 40px'
    }} data-id="element-77"></div>

      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 flex flex-col items-center text-center" data-id="element-78">
        <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full border border-[#00F0FF]/30 bg-[#00F0FF]/5 mb-8 animate-fade-in-up" data-id="element-79">
          <span className="w-2 h-2 rounded-full bg-[#00F0FF] animate-pulse" data-id="element-80"></span>
          <span className="text-[#00F0FF] text-xs font-mono tracking-widest uppercase" data-id="element-81">
            Next Gen Audio Synthesis
          </span>
        </div>

        <h1 className="text-5xl md:text-7xl font-bold tracking-tight text-white mb-6 max-w-4xl" data-id="element-82">
          Synthesize the <br data-id="element-83" />
          <span className="text-transparent bg-clip-text bg-gradient-to-r from-[#00F0FF] to-[#FF00AA]" data-id="element-84">
            Future of Voice
          </span>
        </h1>

        <p className="text-lg md:text-xl text-gray-400 max-w-2xl mb-10 font-light leading-relaxed" data-id="element-85">
          Echecgamer brings studio-quality AI voice generation to your
          fingertips. Create lifelike narration, dialogue, and audio experiences
          with our
          <span className="text-[#00F0FF] font-mono mx-1" data-id="element-86">
            Harmonic Forge™
          </span>{' '}
          engine.
        </p>

        <div className="flex flex-col sm:flex-row gap-4 mb-16" data-id="element-87">
          <Button size="lg" className="min-w-[160px]" data-id="element-88">
            Start Creating
          </Button>
          <Button variant="outline" size="lg" className="min-w-[160px] group" data-id="element-89">
            <Play size={18} className="mr-2 group-hover:text-[#00F0FF]" data-id="element-90" />
            Hear Our Voices
          </Button>
        </div>

        {/* Hero Visualizer */}
        <div className="w-full max-w-5xl h-32 md:h-48 relative" data-id="element-91">
          <div className="absolute inset-0 bg-gradient-to-t from-[#0A0A0F] via-transparent to-transparent z-10" data-id="element-92"></div>
          <WaveformVisualizer bars={60} height={120} className="w-full opacity-60" data-id="element-93" />
          <WaveformVisualizer bars={60} height={120} color="#FF00AA" className="w-full absolute top-0 left-0 opacity-30 blur-sm scale-y-110" data-id="element-94" />
        </div>
      </div>
    </section>;
}